import React, { useEffect, useRef } from 'react';
import { useStateSelector } from 'src/redux';

interface DropdownHeaderProps {
  open: boolean;
  onAddWorkspaceVariable?: () => void;
  onAddAssessmentVariable?: () => void;
}

export const DropdownHeader: React.FC<DropdownHeaderProps> = ({
  open,
  onAddWorkspaceVariable,
  onAddAssessmentVariable,
}) => {
  const colors = useStateSelector(({ theme }) => theme.colors);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (open) {
      const dropdown = document.querySelector('.mnw6qvm');
      if (dropdown && !containerRef.current) {
        const container = document.createElement('div');
        container.className = 'dropdown-header-container';
        container.style.display = 'flex';
        container.style.alignItems = 'center';
        container.style.justifyContent = 'space-between';
        container.style.position = 'sticky';
        container.style.top = '-10px';
        container.style.zIndex = '1';
        container.style.backgroundColor = colors.white;
        container.style.margin = '-10px -8px 4px -8px';
        container.style.padding = '10px 8px 8px 26px';

        const label = document.createElement('span');
        label.textContent = 'VARIABLES';
        label.style.fontFamily = 'Poppins, sans-serif';
        label.style.fontSize = '14px';
        label.style.fontWeight = '600';
        label.style.color = colors.prussianBlue;
        container.appendChild(label);

        const buttonsContainer = document.createElement('div');
        buttonsContainer.style.display = 'flex';
        buttonsContainer.style.gap = '16px';

        const createButton = (text: string, onClick: () => void) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.textContent = text;
          btn.style.background = 'none';
          btn.style.border = 'none';
          btn.style.padding = '0';
          btn.style.cursor = 'pointer';
          btn.style.fontFamily = 'Poppins, sans-serif';
          btn.style.fontSize = '14px';
          btn.style.fontWeight = '500';
          btn.style.backgroundImage = colors.gradient;
          btn.style.webkitBackgroundClip = 'text';
          btn.style.webkitTextFillColor = 'transparent';
          (btn.style as any).backgroundClip = 'text';
          btn.onmousedown = (e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick();
          };
          btn.onmouseenter = () => {
            btn.style.textDecoration = 'underline';
          };
          btn.onmouseleave = () => {
            btn.style.textDecoration = 'none';
          };
          return btn;
        };

        if (onAddWorkspaceVariable) {
          buttonsContainer.appendChild(createButton('+ Workspace Variable', onAddWorkspaceVariable));
        }

        if (onAddAssessmentVariable) {
          buttonsContainer.appendChild(createButton('+ Assessment Variable', onAddAssessmentVariable));
        }

        container.appendChild(buttonsContainer);
        dropdown.prepend(container);
        containerRef.current = container;
      }
    } else {
      // Cleanup
      if (containerRef.current) {
        containerRef.current.remove();
        containerRef.current = null;
      }
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.remove();
        containerRef.current = null;
      }
    };
  }, [open, onAddWorkspaceVariable, onAddAssessmentVariable, colors]);

  return null;
};
